<p-dialog
  [(visible)]="visible"
  [draggable]="false"
  [modal]="true"
  appendTo="body"
  [closable]="true"
  [style]="{ width: '90vw', height: '90vh' }"
  [closeOnEscape]="false"
  (onHide)="close()"
>
  @if(url) {
  <pdf-viewer
    [src]="url"
    [render-text]="true"
    [original-size]="false"
    class="w-full h-full"
  />
  }
</p-dialog>
